export var IntelligentPhotoCaptureVinDecodeStatus;
(function (IntelligentPhotoCaptureVinDecodeStatus) {
    IntelligentPhotoCaptureVinDecodeStatus["FULL"] = "Full";
    IntelligentPhotoCaptureVinDecodeStatus["PARTIAL"] = "Partial";
})(IntelligentPhotoCaptureVinDecodeStatus || (IntelligentPhotoCaptureVinDecodeStatus = {}));
//# sourceMappingURL=IntelligentPhotoCaptureVinDecodeStatus.js.map